import { logout } from "helpers/API Calls/Auth and Profile/auth";
import { useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logoutUser = async () => {
    const response = await logout(); 
    if(response.success){
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      navigate("/login");
    }else{
      toast.error(response.message);
      navigate("/");
    }
  }
    logoutUser();
  }, [navigate]);

  return <></>;
}


export default Logout;
